import React from "react";

const OfferingStatusBadge = ({ isActive }) => {
  return (
    <span
      className={`offering-status-badge ${
        isActive ? "active" : "inactive"
      }`}
    >
      {isActive ? "Active" : "Inactive"}
    </span>
  );
};

export default OfferingStatusBadge;